import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Upload } from 'antd';
import './UserAvatar.scss';
import { EMPTY_OBJECT, EMPTY_STRING, NO_OP } from '../../constants/Constants';
import { notificationHelper } from '../../utils/helper';
import Image from '../Image';
function UserAvatar(props) {
  const {
    userName: {
      firstName,
      lastName
    },
    userProfilePicture,
    isUpload,
    onUpload,
    canDelete,
    onClickDelete,
    isImageLoading
  } = props;
  const UserAvatarInitial = useMemo(() => {
    return [firstName === null || firstName === void 0 ? void 0 : firstName.slice(0, 1), lastName === null || lastName === void 0 ? void 0 : lastName.slice(0, 1)];
  }, [firstName, lastName]);
  const beforeUpload = useCallback(file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      notificationHelper('error', __('Error'), __('You can only upload JPG/PNG file!'), 290, () => {});
    }
    const isLt2M = file.size / 1024 / 1024 < 50;
    if (!isLt2M) {
      notificationHelper('error', __('Error'), __('Image must smaller than 50MB!'), 290, () => {});
    }
    return isJpgOrPng && isLt2M;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "user-avatar-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: !isUpload ? "user-avatar-profile" : "user-avatar-container"
  }, userProfilePicture || isImageLoading ? /*#__PURE__*/React.createElement(Image, {
    src: userProfilePicture,
    className: "user-avatar-image",
    showLoader: isImageLoading
  }) : /*#__PURE__*/React.createElement("span", {
    className: "user-avatar-initial"
  }, "".concat(UserAvatarInitial === null || UserAvatarInitial === void 0 ? void 0 : UserAvatarInitial[0]).concat(UserAvatarInitial === null || UserAvatarInitial === void 0 ? void 0 : UserAvatarInitial[1])), isUpload && /*#__PURE__*/React.createElement("span", {
    className: "user-avatar-uploadicon"
  }, /*#__PURE__*/React.createElement(Upload, {
    accept: "image/x-png,image/jpeg",
    customRequest: onUpload,
    showUploadList: false,
    className: "input-icon-wrapper",
    beforeUpload: beforeUpload
  }, /*#__PURE__*/React.createElement("label", {
    for: "img"
  }, " ", /*#__PURE__*/React.createElement("span", {
    className: "icon-camera"
  }), " ")))), canDelete && userProfilePicture && /*#__PURE__*/React.createElement(Button, {
    className: "remove-picture-button",
    onClick: onClickDelete
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-trash-thick"
  })));
}
;
UserAvatar.propTypes = {
  userName: PropTypes.object.isRequired,
  userProfilePicture: PropTypes.string,
  isUpload: PropTypes.bool,
  onUpload: PropTypes.func,
  canDelete: PropTypes.bool,
  onClickDelete: PropTypes.func,
  isImageLoading: PropTypes.bool
};
UserAvatar.defaultProps = {
  userName: EMPTY_OBJECT,
  userProfilePicture: EMPTY_STRING,
  isUpload: false,
  onUpload: NO_OP,
  canDelete: false,
  onClickDelete: NO_OP,
  isImageLoading: false
};
export default UserAvatar;